import React, { Fragment, useEffect } from 'react'
import { Box } from '@mui/material'
import { StepperShell } from '../../components/_WMS/Stepper'
import { RelocateState } from './types'
import { SkuAndBrandStep } from './steps/SkuAndBrandStep'
import { PositionsStep } from './steps/PositionsStep'
import { ConfirmationStep } from './steps/ConfirmationStep'
import { useProductOrigins } from '../../hooks'

const NewRelocatePage: React.FC = () => {
  const initialSharedState: RelocateState = {
    // Datos del producto
    sku: '',
    productOriginId: null,
    productOriginName: '',
    isGreenSale: false,
    
    // Posiciones
    posicionOrigen: '',
    cantidad: null,
    posicionDestino: '',
    availableStock: undefined,
    originPositionId: undefined,
    destinyPositionId: undefined,
    stockKeepingUnitId: undefined,
    
    // Manejo de merma
    isDamaged: false,
    originPositionType: undefined,
    originZone: undefined,

    // Posiciones sugeridas
    availablePositions: undefined,
    suggestedPositions: undefined,
    
    // Manejo de lotes/fechas de expiración
    hasBatchManagement: false,
    hasExpirationDate: false,
    selectedBatch: undefined,
    availableBatches: undefined,
    showBatchModal: false,
    expirationDays: 0,

    // Modo DUN (se activa al escanear un código de caja en el paso 1)
    isDun: false,
    dunCode: undefined,
    dunQty: undefined,
    stockKeepingUnitDunId: undefined,
    typePackageName: undefined,
    cantidadDun: null,

    // Comentarios y documentos
    documentNumber: undefined,
    observations: undefined,
    requiresComments: false,
    
    // Estados
    error: undefined,
    isLoading: false
  }

  const { getProductOrigins } = useProductOrigins()

  useEffect(() => {
    // Cargar marcas al inicializar la página
    getProductOrigins()
  }, [])

  return (
    <Fragment>
      {/* Los margenes negativos cancelan el padding del <main> del Layout y el
          fondo blanco tapa su gris, para que la pantalla llegue de borde a
          borde. Mismo wrapper que ASNLocate y ASNReceptionLpn. */}
      <Box sx={{ mx: -2, mt: -3, mb: -3, minHeight: 'calc(var(--app-vh) - 64px)', backgroundColor: '#FFF' }}>
        <StepperShell<RelocateState>
          steps={[
            (props) => <SkuAndBrandStep {...props} />,
            (props) => <PositionsStep {...props} />,
            (props) => <ConfirmationStep {...props} />
          ]}
          initialSharedState={initialSharedState}
        />
      </Box>
    </Fragment>
  )
}

export default NewRelocatePage